import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

import avatarImg from 'assets/images/avatar.jpg';

import useUser from 'hooks/useUser';

import { useAppDispatch } from 'store/hooks';

import { signOut } from 'store/user/user.slice';

import {
  ImageContainer,
  Menu,
  MenuBody,
  MenuHeader,
  UserDropdownContainer,
} from './user-dropdown.styles';

export const UserDropdown = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const { currentUser } = useUser();

  const handleSignOut = () => {
    dispatch(signOut());
    navigate('/entrar');
  };

  return (
    <UserDropdownContainer drop="down-centered">
      <ImageContainer className="bg-transparent">
        {/* Nome ao lado da foto (out/2026, pedido do Bruno) */}
        <span className="user-name" title={currentUser?.name}>
          {currentUser?.name}
        </span>
        <img
          src={currentUser?.imageUrl || avatarImg}
          alt={currentUser?.name}
          referrerPolicy="no-referrer"
        />
      </ImageContainer>
      <Menu>
        <span className="tooltipArrow" />
        <MenuHeader>
          <h4>{currentUser?.name}</h4>
          <span>{currentUser?.email}</span>
        </MenuHeader>
        <MenuBody>
          <Link to="/perfil">Acessar perfil</Link>
          <Link to="/conta">Minha conta / Plano</Link>
          {currentUser?.isAdmin && (
            <Link to="/admin/dashboard">Mudar para admin</Link>
          )}
          <Link to="/integracoes">Minhas integrações</Link>
          <span onClick={handleSignOut}>Sair</span>
        </MenuBody>
      </Menu>
    </UserDropdownContainer>
  );
};
